<template>
	<div>
		<div class="row">
			<div class="mb-3">          
				<el-collapse>
					<el-collapse-item>
						<template slot="title">
							<span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
						</template>
						<el-form label-position="top" label-width="100px">
							<div class="row">
								<div class="col-md-6" v-if="tabName=='sales_b2b' || tabName=='progress_piutang'">	
									<el-form-item label="Date Range:">
										<div class="block">								
											<el-date-picker
											v-model="dateRange"
											type="daterange"
											align="right"
											size="small" 
											unlink-panels
											range-separator="-"
											start-placeholder="Start date"
											end-placeholder="End date"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd"
											:picker-options="pickerOptions">
											</el-date-picker>
										</div>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='sales_b2b'">
									<el-form-item label="Period">
										<el-radio-group v-model="period" size="small" name="period">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.period" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='sales_b2b'">
									<el-form-item label="Detail">
										<el-radio-group v-model="detail1" size="small" name="detail1">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.detail1" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>

								<div class="col-md-6" v-if="tabName=='piutang' && piutanggroup=='detail'">
									<el-form-item label="Document Number">
										<el-input placeholder="Type Document Number ..." v-model="donumber" maxlength="50" clearable="true"></el-input>
									</el-form-item>
								</div>
								
							</div>
							<div class="row">
								<div class="col-md-6">
									<el-form-item label="Customer Name:">
										<el-select v-model="cust" clearable filterable placeholder="Customer Name" size="medium" style="width:100%;">
											<el-option v-for="item3 in customer.list" :key="item3.CustomerId" :label="item3.CustomerName" :value="item3.CustomerId">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='piutang'" v-show="false">
									<el-form-item label="Aging:">
										<el-select v-model="agingId" clearable filterable placeholder="Aging" size="medium" style="width:100%;">
											<el-option v-for="item3 in aging.list" :key="item3.Aging" :label="item3.Aging" :value="item3.Aging">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
								<div class="col-md-6" v-if="tabName=='piutang'">
									<el-form-item label="Group">
										<el-radio-group v-model="piutanggroup" size="small" name="piutanggroup">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.piutanggroup" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row" v-if="tabName=='sales_b2b'">
								<div class="col-md-12">
									<el-form-item label="Customer Group">
										<el-radio-group v-model="group" size="small" name="group">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.group" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row" v-if="tabName=='sales_b2b'">
								<div class="col-md-4">
									<el-form-item label="Status">
										<el-radio-group v-model="active" size="small" name="active">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.active" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
								<div class="col-md-6">
									<el-form-item label="Chart">
										<el-radio-group v-model="chartparam" size="small" name="chartparam">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.chartparam" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
							<div class="row" v-if="tabName=='sales_b2b'">
								<div class="col-md-12">
									<el-form-item label="Category">
										<el-radio-group v-model="category" size="small" name="category">
											<el-radio-button :label="item5.value" v-for="(item5, index5) in options.category" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
										</el-radio-group>
									</el-form-item>
								</div>
							</div>
								
							<div class="row mt-2">
								<div class="col-md-6">
									<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
								</div>
							</div>
						</el-form>
					</el-collapse-item>
				</el-collapse>
			</div>

			<div class="row" v-if="tabName=='sales_b2b'">
				<div class="col-md-3 mb-3">
					<el-checkbox v-model="showchart">Show Chart</el-checkbox>
				</div>
				<div class="col-md-4 mb-3" v-if="showchart">
					<el-radio-group v-model="charttype">
						<el-radio label="barchart" size="small">Bar Chart</el-radio>
						<el-radio label="linechart" size="small">Line Chart</el-radio>
					</el-radio-group>
				</div>

				<div class="col-md-3" v-if="showchart && charttype=='barchart' ">
					<el-checkbox v-model="stacked">Stacked</el-checkbox>
				</div>
				
			</div>
			<div class="mb-0" >
				<BarChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="380" v-if="showchart && charttype=='barchart'" />
				<LineChart v-loading.body="loading.table" :data="chartdata" :width="500" :height="192" v-if="showchart && charttype=='linechart'" style="margin-top:20px;"/>
			</div>

			<div class="mt-0">
				<ReportResultTable :reportname="'CustomerReport'" :reportdata="reportdata" :loading="loading.table" :reporturl="urlRequestParams" :issuccess="loading.isSuccess" style="width:100%;"/> 
			</div>
		</div>
	</div>
</template>

<script>

import Customer from '@/components/page/Customer.js'
import ReportResultTable from '@/views/pages/ReportResultTable3.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'

export default
{
	extends: Customer,
	props: ['tabIndex','tabName', 'tabLabel'],
	components: { 
		//ReportParamSelect,
		ReportResultTable,
		LineChart,
		BarChart,
		//Loader,
	},

	data(){
		return {
			date: { 
				Start: this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,
				End: this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin, 
			},
			charttype: 'linechart', //barchart //linechart
			urlRequestParams: '',
			dateRange: [this.$route.query.dateStart ? this.$route.query.dateStart : Penanggalan().tahunSekarang,this.$route.query.dateEnd ? this.$route.query.dateEnd : Penanggalan().kemarin], 
			aging: {
				list: [],
			},
			agingId: '',
			piutanggroup: 'customer',

			options: {
				period:[
					{ value: '', name: 'ALL' },
					{ value: 'monthly', name: 'MONTHLY'  },
					{ value: 'yearly', name: 'YEARLY' },
				],
				detail1:[
					{ value: "", name: "ALL" }, 
					{ value: "customer", name: "BY CUSTOMER" }, 
				],
				category:[
					{ value: "", name: "ALL" }, 
					{ value: "tipe", name: "BY TYPE", field: "Tipe" }, 
					{ value: "category", name: "BY CATEGORY", field: "Category" }, 
					{ value: "RFID", name: "RFID" }, 
					{ value: "VOUCHER", name: "VOUCHER" }, 
					{ value: "STORE", name: "STORE" }, 
					{ value: "LPG", name: "LPG" }, 
				],
				group:[
					{ value: "", name: "ALL" }, 
					{ value: "group", name: "BY GROUP", field: "GroupName"  }, 
					{ value: "34", name: "PEMERINTAH" }, 
					{ value: "58", name: "AFILIASI" }, 
					{ value: "59", name: "SWASTA" },
					{ value: "P1", name: "PANGKALAN LPG" },
				],
				active:[
					{ value: "", name: "ALL" }, 
					{ value: "1", name: "ACTIVE" }, 
					{ value: "0", name: "NON ACTIVE" }, 
				],
				chartparam:[
					{ value: "Amount", name: "BY AMOUNT" }, 
					{ value: "CustCount", name: "BY NUM OF CUSTOMER" }, 
				],
				piutanggroup: [
					{ value: "detail", name: "DETAIL" }, 
					//{ value: "summary", name: "SUMMARY" }, 
					{ value: "aging", name: "AGING" }, 
					{ value: "customer", name: "CUSTOMER" }, 
				]
			},

			reportdata: [],
			chartdata: [],
			showchart: false,
			stacked: true,
			tabIndexParam: this.$route.query.tab ? this.$route.query.tab : '',
			period: this.$route.query.period ? this.$route.query.period : '',
			detail1: this.$route.query.detail1 ? this.$route.query.detail1 : '',
			category: this.$route.query.category ? this.$route.query.category : 'category',
			group: this.$route.query.group ? this.$route.query.group : '',
			cust: this.$route.query.cust ? this.$route.query.cust : '',
			active: this.$route.query.active ? this.$route.query.active : '',
			chartparam: "Amount",
			donumber: '',
			
			loading: {
				table: false,
				chart: false,
				isSuccess: false,
			},

			pickerOptions: {
				shortcuts: [{
					text: 'Last week',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last month',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					picker.$emit('pick', [start, end]);
					}
				}, {
					text: 'Last 3 months',
					onClick(picker) {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					picker.$emit('pick', [start, end]);
					}
				}]
			},

			limit: 100,

		}
	},
	watch:
	{
		reportdata() { this.refreshChart(); },
		stacked() { this.refreshChart(); },
	}, 
    mounted()
    {
		Array.from(document.querySelectorAll('aside li.nav-item a')).map((e)=>{e.classList.remove('active')})
        document.querySelector('li.nav-item a.'+window.location.pathname.split('/')[1]).classList.add('active')
		
        this.$emit('childrenRoute');
		
		if(this.tabName=='sales_b2b')
			this.loadCustomerList()
		else
			this.loadCustomerListPiutang()

		if(this.tabName=='piutang') {
			this.dateRange = [Penanggalan().sekarang, Penanggalan().sekarang] 
		}

			this.loadAgingList()
		this.resumePilihan()
		
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')            
		},
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		refreshChart() {
			let opt = this.getoption(this.category, this.options.category)
			let a = opt && opt.field ? opt.field : ""

			opt = this.getoption(this.group, this.options.group)
			if (opt && opt.field) a = opt.field
			
			let b = "Period"
			let c = Rainbow

			let div = this.chartparam == "Amount" ? 1000000 : 1;
			
			this.chartdata = this.processBarChart(this.reportdata.data, a, "", this.chartparam, false, b, "", div, 2, c, false, false, false, this.stacked);
		},

		async loadAgingList() {
			let url = Config().apiURL + "/customer/aginglist"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.aging.length) {
					this.aging.list = result.data.aging;
				}
			})
		},

		async resumePilihan() {
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/customer/customerreport?'
			else if (this.tabIndex == 1) {
				if(this.tabIndexParam != '' && this.cust == '')
					this.urlRequestParams+='/customer/top-piutang?'
				else
					this.urlRequestParams+='/customer/piutang?'
			}
			else if (this.tabIndex == 2) this.urlRequestParams+='/v1/customer/progressPiutang?'

			this.urlRequestParams+='&date-range-start='+ (this.dateRange && this.dateRange[0] ? this.dateRange[0]:'') //this.date.Start
			this.urlRequestParams+='&date-range-end='+(this.dateRange && this.dateRange[1] ? this.dateRange[1]:'')  //this.date.End
			//this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			//this.urlRequestParams+='&date-range-end='+ this.dateRange[1]

			this.urlRequestParams+='&period='+this.period
			this.urlRequestParams+='&detail='+this.detail1
			this.urlRequestParams+='&category='+this.category
			this.urlRequestParams+='&group='+this.group
			this.urlRequestParams+='&customer='+this.cust
			this.urlRequestParams+='&aging='+this.agingId
			this.urlRequestParams+='&active='+this.active	
			this.urlRequestParams+='&group='+this.piutanggroup
			this.urlRequestParams+='&donumber='+this.donumber
			this.urlRequestParams+='&limit='+this.limit

			//set limit to 0 (no limit) after first load //
			this.limit = 0

			this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{ 
					this.reportdata = response.data;
					this.loading.isSuccess = true;
					this.tabIndexParam = ''
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
		
		applyFilter() {
			this.resumePilihan()
        },
			
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.el-select-dropdown__item {
  max-width: 900px;
  white-space: normal;
  overflow: unset;
  height: auto;
  line-height: normal;
  padding-top: 10;
  padding-bottom: 10;
}

</style>